// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__NKrjm","paramInput":"JobSimulator_paramInput__-XIFM","input":"JobSimulator_input__3SG-U"};